import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  Box,
  Button,
  InputAdornment,
  TextField,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import PageBanner from "../components/application/PageBanner";
import { BannerTexts, GeneratePasswordText, SnackbarMsg } from "../data/texts";
import { Images } from "../models/assets-files";
import { ImageService } from "../services/image.service";
import { UtilsService } from "../services/utils.service";
import { showSnackbar } from "../store/system.store";
import useScreen from "../components/common/UseScreen";

const GeneratePasswordPage = () => {
  const theme = useTheme();
  const [password, setPassword] = useState("");
  const { isDesktop } = useScreen();
  const dispatch = useDispatch();

  const onCopyPassword = () => {
    if (!password) return;
    navigator.clipboard.writeText(password);
    dispatch(
      showSnackbar({
        msg: SnackbarMsg.PASSWORD_COPY,
      })
    );
  };
  return (
    <Box sx={{ padding: "24px" }}>
      <PageBanner
        imageSrc={ImageService.getLocalImgPath(
          Images.Folders.BANNERS,
          Images.Banners.LOCK,
          "png"
        )}
        title={BannerTexts.GENERATE_PASSWORD_TITLE}
        subtitle={BannerTexts.GENERATE_PASSWORD_TEXT}
      >
        <slot name="content">
          <TextField
            slotProps={{
              input: {
                readOnly: true,
                endAdornment: (
                  <Box onClick={onCopyPassword} sx={{ cursor: "pointer" }}>
                    <InputAdornment position="end">
                      <ContentCopyIcon />
                    </InputAdornment>
                  </Box>
                ),
              },
            }}
            value={password}
            sx={{
              "& input": {
                cursor: "default !important",
              },
              background: "white",
              borderRadius: "8px",
              width: isDesktop ? "50%" : "90%",
              marginBottom: "10px",
            }}
          />
          <Button
            onClick={() => {
              setPassword(UtilsService.generatePassword(16));
            }}
            sx={{
              background: theme.palette.text.primary,
              color: "white",
              padding: "15px",
              borderRadius: "8px",
              width: isDesktop ? "50%" : "90%",
            }}
          >
            {GeneratePasswordText.GENERATE_PASSWORD}
          </Button>
        </slot>
      </PageBanner>
    </Box>
  );
};

export default GeneratePasswordPage;
